export default __webpack_public_path__ + "static/media/sticker-5.178e2c7f.png";